import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_installment_state_box = _resolveComponent("installment-state-box")

  return (_openBlock(), _createBlock(_component_installment_state_box, { "data-qa": "StretchPay:allPaid" }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.InstallmentProgressNextTitle), 1 /* TEXT */)
    ]),
    value: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.InstallmentProgressAllPaid), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }))
}